/*
 * @Author: ChengQing
 * @Date: 2020-09-14 15:17:49
 * @Last Modified by: ChengQing
 * @Last Modified time: 2020-09-21 14:52:34
 */
import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { connect } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import { stationgisApi } from '@/api/newApi'
import "./style.scss";
import MyIcon from "@/components/MyIcon";
import bgNormal from "@/assets/mark-bg-normal.png";
import bgTingji from "@/assets/mark-bg-tingji.png";
import bgGuzhang from "@/assets/mark-bg-guzhang.png";
import { Map, Markers } from "react-amap";
import { isHaveVal } from '../../../utils/common'

const mapKey = "89443754ab7f65123c9ec431135a456f"; //高德地图mapKey
let center = {
  // 设置默认中心点位置 =》 成都天府广场
  longitude: 104.065971,
  latitude: 30.657672,
};

const Pages = ({ history, userInfo }) => {
  // 厂站marker
  const [markers, setMarkers] = useState([]);
  // 厂站状态值
  const [stateObj, setStateObj] = useState({
    normal: 0,
    yichang: 0,
    tingji: 0,
  });
  /**
   * 获取所有标记点位
   * @param {*} {}
   * @returns
   */
  const getStationListData = () => {
    const marks = [];
    let stationIds = userInfo.stationIds ? userInfo.stationIds.split(',') : [];
    stationgisApi.selectGisStationList(stationIds)
      .then((res) => {
        if (res.status == 0) {
          const list = res.data ? res.data : [];
          let normal = 0;
          let yichang = 0;
          let tingji = 0;
          let alllongitude = 0;
          let alllatitude = 0;
          list.map((item) => {
            if (item.stationStatus == 0) { // (0 - 正常 1 - 异常 2 - 离线)
              normal++;
            } else if (item.stationStatus == 1) {
              yichang++;
            } else if (item.stationStatus == 2) {
              tingji++;
            }
            alllongitude += item.lon;
            alllatitude += item.lat;
            marks.push({
              position: {
                ...item,
                name: item.aliasName,
                longitude: item.lon,
                latitude: item.lat,
              },
            });
          });
          center = {
            longitude: alllongitude ? alllongitude / list.length : center.longitude,
            latitude: alllatitude ? alllatitude / list.length : center.latitude,
          };
          setStateObj({ normal, yichang, tingji });
          setMarkers(() => {
            return [...marks];
          });
        }
      })
  }
  useEffect(() => {
    getStationListData()
    return () => { }
  }, [])

  // 当前点击厂站的详情数据
  const [currentData, setCurrentData] = useState({});
  // 是否展示详情弹窗
  const [noticeFlag, setnoticeFlag] = useState(false);

  // 跳转到工艺流程页
  const goto = () => {
    history.replace("/stationManagement/factoryProgress?id=" + currentData.id);
  };

  // 地图marker点击事件
  const markersEvents = {
    created: (allMarkers) => { },
    click: (MapsOption, marker) => {
      const { position } = marker.getExtData();
      getMarkersDetail(position);
    },
  };

  /**
   * 获取点击点位详情
   * @param {*} {}
   * @returns
   */
  const getMarkersDetail = (position) => {
    stationgisApi.selectGisStationInfo({ stationId: position.id })
      .then((res) => {
        if (res.status * 1 == 0) {
          const data = JSON.parse(JSON.stringify(res.data))

          data.handleWaterTotal = isHaveVal(data.handleWaterTotal) ? (data.handleWaterTotal * 1).toFixed(2) : '暂无'
          data.js_COD = isHaveVal(data.js_COD) ? (data.js_COD * 1).toFixed(2) : '暂无'
          data.js_TP = isHaveVal(data.js_TP) ? (data.js_TP * 1).toFixed(2) : '暂无'
          data.js_NH3N = isHaveVal(data.js_NH3N) ? (data.js_NH3N * 1).toFixed(2) : '暂无'
          data.js_TN = isHaveVal(data.js_TN) ? (data.js_TN * 1).toFixed(2) : '暂无'

          data.cs_COD = isHaveVal(data.cs_COD) ? (data.cs_COD * 1).toFixed(2) : '暂无'
          data.cs_TP = isHaveVal(data.cs_TP) ? (data.cs_TP * 1).toFixed(2) : '暂无'
          data.cs_NH3N = isHaveVal(data.cs_NH3N) ? (data.cs_NH3N * 1).toFixed(2) : '暂无'
          data.cs_TN = isHaveVal(data.cs_TN) ? (data.cs_TN * 1).toFixed(2) : '暂无'
          data.cs_PH = isHaveVal(data.cs_PH) ? (data.cs_PH * 1).toFixed(2) : '暂无'
          data.cs_SSLL = isHaveVal(data.cs_SSLL) ? (data.cs_SSLL * 1).toFixed(2) : '暂无'
          data.yesterdayHandleWater = isHaveVal(data.yesterdayHandleWater) ? (data.yesterdayHandleWater * 1).toFixed(2) : '暂无'

          setCurrentData(data);
          setnoticeFlag(true);
        }
      })
  };

  // 厂站marker
  const renderMarkerLayout = (extData) => {
    const {
      position: { stationStatus },
    } = extData;
    return (
      <div className="markerLayout">
        <div className="markerLayout-bg">
          <img
            className="markerLayout-bg-img"
            src={
              stationStatus == 0
                ? bgNormal
                : stationStatus == 1
                  ? bgGuzhang
                  : bgTingji
            }
          />
        </div>
        <div
          className={
            stationStatus == 0
              ? "markerLayout-text border-normal"
              : "markerLayout-text border-Tingji"
          }
        >
          <div style={{ minWidth: "60px", whiteSpace: 'nowrap' }}>{extData.position.name}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="map-page baseContent">
      <div style={{ width: "100%", height: "100%" }}>
        <Map
          amapkey={mapKey}
          plugins={["ToolBar", "Scale"]}
          center={center}
          zoom={10}
        >
          <Markers
            markers={markers}
            events={markersEvents}
            render={renderMarkerLayout}
          />
        </Map>
      </div>
      {/* 右上角状态信息栏 */}
      <div className="state-box">
        {
          Object.keys(stateObj).map((key) => {
            return (
              <div className="state-item"
                key={key}>
                <div className="dote" style={{ background: key == 'tingji' ? "#B4BCC4" : (key == 'yichang' ? "#F04B4B" : '') }}></div>
                <div className="state-txt">{key == 'normal' ? '正常' : (key == 'tingji' ? '停机' : '异常')}</div>
                <div className="state-num">{stateObj[key]}</div>
              </div>
            )
          })
        }
      </div>

      {/* 弹框信息 */}
      {currentData.id &&
        <div
          className={
            noticeFlag
              ? "info-con infoConFadeIn-active"
              : "info-con infoConFadeOut-active"
          }
        >
          <div className="info-con-title">
            <span>{currentData.name}</span>
            <CloseOutlined
              onClick={() => setnoticeFlag(false)}
              style={{ color: "#B4BCC4", cursor: "pointer" }}
            />
          </div>
          <div className="info-con-main">
            <div className="info-con-main-03 info-con-main-item"
              style={{ paddingTop: 0 }}>
              <div className="main-title info-item">
                <MyIcon
                  type="iconyunyingshuju"
                  style={{
                    marginRight: "8px",
                    color: "#2D99FF",
                    fontSize: "16px",
                  }}
                />
                <span>运营数据</span>
              </div>
              <div className="shuju-item-full shuju-info">
                <div className="info-des info-item">
                  <span>污水处理总量</span>
                  <span className="unit">m³</span>
                </div>
                <div className="shuju-val">{currentData.handleWaterTotal}</div>
              </div>
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>进水COD</span>
                  <span className="unit">mg/L</span>
                </div>
                <div className="shuju-val">{currentData.js_COD}</div>
              </div>
              {
                currentData.js_TP != '暂无' &&
                <div className="shuju-item shuju-info">
                  <div className="info-des info-item">
                    <span>进水TP</span>
                    <span className="unit">mg/L</span>
                  </div>
                  <div className="shuju-val">{currentData.js_TP}</div>
                </div>
              }
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>进水NH3-N</span>
                  <span className="unit">mg/L</span>
                </div>
                <div className="shuju-val">{currentData.js_NH3N}</div>
              </div>
              {
                currentData.js_TN !== '暂无' &&
                <div className="shuju-item shuju-info">
                  <div className="info-des info-item">
                    <span>进水TN</span>
                    <span className="unit">mg/L</span>
                  </div>
                  <div className="shuju-val">{currentData.js_TN}</div>
                </div>
              }
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>出水COD</span>
                  <span className="unit">mg/L</span>
                </div>
                <div className="shuju-val">{currentData.cs_COD}</div>
              </div>
              {
                currentData.cs_TP !== '暂无' &&
                <div className="shuju-item shuju-info">
                  <div className="info-des info-item">
                    <span>出水TP</span>
                    <span className="unit">mg/L</span>
                  </div>
                  <div className="shuju-val">{currentData.cs_TP}</div>
                </div>
              }
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>出水NH3-N</span>
                  <span className="unit">mg/L</span>
                </div>
                <div className="shuju-val">{currentData.cs_NH3N}</div>
              </div>
              {
                currentData.cs_TN !== '暂无' &&
                <div className="shuju-item shuju-info">
                  <div className="info-des info-item">
                    <span>出水TN</span>
                    <span className="unit">mg/L</span>
                  </div>
                  <div className="shuju-val">{currentData.cs_TN}</div>
                </div>
              }
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>出水PH</span>
                  <span className="unit"></span>
                </div>
                <div className="shuju-val">{currentData.cs_PH}</div>
              </div>
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>出水瞬时流量</span>
                  <span className="unit">m³/h</span>
                </div>
                <div className="shuju-val">{currentData.cs_SSLL}</div>
              </div>
              <div className="shuju-item shuju-info">
                <div className="info-des info-item">
                  <span>日处理水量</span>
                  <span className="unit">m³</span>
                </div>
                <div className="shuju-val">{currentData.yesterdayHandleWater}</div>
              </div>
            </div>
            <div className="info-con-main-01 info-con-main-item">
              <div className="main-title info-item">
                <MyIcon
                  type="iconjichuxinxi"
                  style={{
                    marginRight: "8px",
                    color: "#2D99FF",
                    fontSize: "16px",
                  }}
                />
                <span>基本信息</span>
              </div>
              {currentData.stationPic && <img
                className="info-item"
                src={currentData.stationPic.split(',')[0]}
                alt={currentData.name + '图片加载失败'}
                style={{
                  width: "100%",
                  height: "height: 148px",
                  borderRadius: "4px",
                }}
              />}
              <div className="info-des info-item">
                <span>投资总预算：</span>
                <span>{currentData.totalBudget}万元</span>
              </div>
              <div className="info-des info-item">
                <span>建设单位：</span>
                <span>{currentData.construction}</span>
              </div>
              <div className="info-des info-item">
                <span>设计处理规模：</span>
                <span>{currentData.designProc}m³/d</span>
              </div>
              <div className="info-des info-item">
                <span>处理工艺：</span>
                <span>{currentData.treatProcess}</span>
              </div>
            </div>
            <div className="info-con-main-02 info-con-main-item">
              <div className="main-title info-item">
                <MyIcon
                  type="iconyunyingguanlixinxi"
                  style={{
                    marginRight: "8px",
                    color: "#2D99FF",
                    fontSize: "16px",
                  }}
                />
                <span>运营管理信息</span>
              </div>
              <div className="info-des info-item">
                <span>厂站负责人：</span>
                <span>{currentData.opeLeader}</span>
              </div>
              <div className="info-des info-item">
                <span>运营单位：</span>
                <span>{currentData.operate}</span>
              </div>
              <div className="info-des info-item">
                <span>联系电话：</span>
                <span>{currentData.opeLeaderPho}</span>
              </div>
            </div>
          </div>
          <div className="info-con-footer">
            <Button onClick={() => goto()} type="primary info-con-footer-primary">
              工艺流程
            </Button>
          </div>
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
